export class CompareStartsWith {
    parent;
    constructor(parent) {
        this.parent = parent;
    }
    get comparer() {
        return this.parent;
    }
    get similarityByStartsWith() {
        const { userInput, cleanedExpectedInput } = this.comparer;
        let matchingCharacters = 0;
        for (let i = 0; i < userInput.length && i < cleanedExpectedInput.length && cleanedExpectedInput[i] === userInput[i]; i++) {
            matchingCharacters++;
        }
        return (100 * matchingCharacters) / cleanedExpectedInput.length;
    }
}
